import {StyleSheet} from 'react-native';

import {onyxLightest} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    color: onyxLightest,
    fontSize: 24,
    textShadowColor: 'transparent',
  },
  filterWeb: {
    marginBottom: 14,
  },
});
